import type { Way } from '../../data/full/path-layout';
import type { DecorId } from '../../data/types';
import type { PaletteToken } from '../../shared/palette';
import { parseHexColor } from '../palette';

export const AHEAD_TOKENS: Readonly<Record<DecorId, PaletteToken>> = {
  lake: 'healer',
  pumpui: 'mage',
  dome: 'or',
  ambyss: 'turquoise',
};

export const PATH_COLORS = {
  meadow: parseHexColor('#2c4a36'),
  tuft: parseHexColor('#4d7a4c'),
  canopy: parseHexColor('#24452f'),
  canopyDark: parseHexColor('#1d3a2a'),
  canopyLight: parseHexColor('#3f6b45'),
  canopyEdge: parseHexColor('#14261a'),
  shade: parseHexColor('#0d1a12'),
  rim: parseHexColor('#ff9fc0'),
  plank: parseHexColor('#5e3b30'),
  plankDark: parseHexColor('#553429'),
  plankEdge: parseHexColor('#24121c'),
  pole: parseHexColor('#2a1830'),
  brass: parseHexColor('#f0b050'),
  bulb: parseHexColor('#fff2c0'),
  glow: parseHexColor('#ffc860'),
  firefly: parseHexColor('#fff6d8'),
  outline: parseHexColor('#060a1c'),
} as const;

export const FLOWERS = ['#ff8fb8', '#8fb0ff', '#b58cff', '#ffa860', '#fff2e0'].map(parseHexColor);
export const FOLK = ['#ff9a3d', '#7cf2b0', '#5fd0c8', '#f0b050', '#ff6fa8', '#b8c4ee'].map(
  parseHexColor,
);

export const turnOf = (way: Way, heading: 1 | -1): number =>
  way.down ? (heading * Math.PI) / 2 : heading > 0 ? 0 : Math.PI;

export const towardTrail = (way: Way, side: -1 | 1): number =>
  way.down ? (side * Math.PI) / 2 : side < 0 ? 0 : Math.PI;
